import styled from "@emotion/styled";

export const ContentContainer = styled.div`
  display: flex;
  padding: 20px 28px 20px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const SyncWorkspaceInfoContainer = styled.div`
  display: flex;
  padding: 12px 28px 20px 40px;
  align-self: stretch;
  gap: 12px;
  flex-direction: column;
`;
